import { StaffPermission } from '../types/user';

export const PERMISSION_LABELS: Record<StaffPermission, string> = {
  [StaffPermission.VIEW_BOOKINGS]: 'View Bookings',
  [StaffPermission.MANAGE_BOOKINGS]: 'Manage Bookings',
  [StaffPermission.VIEW_REVENUE]: 'View Revenue',
  [StaffPermission.VIEW_PAYOUTS]: 'View Payouts',
  [StaffPermission.MANAGE_AVAILABILITY]: 'Manage Availability',
  [StaffPermission.MANAGE_VENUE_DETAILS]: 'Manage Venue Details',
  [StaffPermission.VIEW_REVIEWS]: 'View Reviews',
  [StaffPermission.RESPOND_TO_REVIEWS]: 'Respond to Reviews',
  [StaffPermission.MANAGE_COUPONS]: 'Manage Coupons',
  [StaffPermission.VIEW_CUSTOMERS]: 'View Customers',
  [StaffPermission.VIEW_STAFF]: 'View Staff',
  [StaffPermission.MANAGE_STAFF]: 'Manage Staff',
  [StaffPermission.VIEW_ANALYTICS]: 'View Analytics',
};

export const STAFF_ROLE_PRESETS = {
  Manager: [
    StaffPermission.VIEW_BOOKINGS,
    StaffPermission.MANAGE_BOOKINGS,
    StaffPermission.VIEW_REVENUE,
    StaffPermission.VIEW_PAYOUTS,
    StaffPermission.MANAGE_AVAILABILITY,
    StaffPermission.MANAGE_VENUE_DETAILS,
    StaffPermission.VIEW_REVIEWS,
    StaffPermission.RESPOND_TO_REVIEWS,
    StaffPermission.MANAGE_COUPONS,
    StaffPermission.VIEW_CUSTOMERS,
    StaffPermission.VIEW_STAFF,
    StaffPermission.MANAGE_STAFF,
    StaffPermission.VIEW_ANALYTICS,
  ],
  'Front Desk': [
    StaffPermission.VIEW_BOOKINGS,
    StaffPermission.MANAGE_BOOKINGS,
    StaffPermission.MANAGE_AVAILABILITY,
    StaffPermission.VIEW_CUSTOMERS,
  ],
  Viewer: [StaffPermission.VIEW_BOOKINGS, StaffPermission.VIEW_REVIEWS, StaffPermission.VIEW_ANALYTICS],
};
